import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSiteContext } from '../../context/SiteContext';
import SafeIcon from '../../common/SafeIcon';

const SyncTick = () => {
  const { syncTickActive } = useSiteContext();

  return (
    <AnimatePresence>
      {syncTickActive && (
        <motion.div
          initial={{ opacity: 0, y: 10, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 5, scale: 0.95 }}
          transition={{ duration: 0.2 }}
          className="fixed bottom-4 left-4 z-50 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-[11px] font-medium backdrop-blur-md"
        >
          <SafeIcon name="Check" className="w-3 h-3" />
          <span>Updated</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SyncTick;